import { calendarEventsReducer } from 'data/upshifter/CalendarEvents/reducer'
import { documentsReducer } from 'data/upshifter/Documents/reducer'
import { featuredShiftsReducer } from 'data/upshifter/FeaturedShifts/reducer'
import { featuredShiftsCampaignReducer } from 'data/upshifter/FeaturedShiftsCampaign/reducer'
import { upshifterLoadingReducer } from 'data/upshifter/Loading/reducer'
import { upshifterMyShiftsReducer } from 'data/upshifter/MyShifts/reducer'
import { notificationPreferencesReducer as upshifterNotificationPreferencesReducer } from 'data/upshifter/NotificationPreferences/reducer'
import { notificationsReducer as upshifterNotificationsReducer } from 'data/upshifter/Notifications/reducer'
import { punchCardsReducer as upshifterPunchCardsReducer } from 'data/upshifter/PunchCards/reducer'
import { upshifterRecommendedShiftsReducer } from 'data/upshifter/RecommendedShifts/reducer'
import { upshifterShiftsReducer } from 'data/upshifter/Shifts/reducer'
import { unreadNotificationsReducer as upshifterUnreadNotificationsReducer } from 'data/upshifter/UnreadNotifications/reducer'
import { userCertificatesReducer as upshifterUserCertificatesReducer } from 'data/upshifter/UserCertificates/reducer'
import { locationReducer } from 'data/upshifter/Location/reducer'
import { combineReducers } from 'redux'
import { authReducer } from 'data/common/Auth/reducer'
import { shiftReducer as upshifterShiftReducer } from 'data/upshifter/Shift/reducer'
import { favoredBusinessesReducer } from 'data/upshifter/FavoredBusinesses/reducer'
import { favorerBusinessesReducer } from 'data/upshifter/FavorerBusinesses/reducer'
import { payStubsReducer } from 'data/upshifter/PayStubs/reducer'
import { accruedSickHoursReducer } from 'data/upshifter/AccruedSickHours/reducer'
import { PendingReviewShiftsReducer } from 'data/upshifter/PendingReviewShifts/reducer'
import { strikesReducer } from 'data/upshifter/Strike/reducer'
import { upshifterExperiencesReducer } from 'data/upshifter/UpshifterExperience/reducer'

const rootReducer = combineReducers({
  upshifterShift: upshifterShiftReducer,
  auth: authReducer,
  upshifterNotifications: upshifterNotificationsReducer,
  upshifterUnreadNotifications: upshifterUnreadNotificationsReducer,
  documents: documentsReducer, // Upshifter documents
  upshifterLoadingReducer,
  calendarEvents: calendarEventsReducer,
  featuredShifts: featuredShiftsReducer,
  featuredShiftsCampaign: featuredShiftsCampaignReducer,
  pendingReviewShifts: PendingReviewShiftsReducer,
  locations: locationReducer,
  upshifterShifts: upshifterShiftsReducer,
  myShifts: upshifterMyShiftsReducer,
  recommendedShifts: upshifterRecommendedShiftsReducer,
  payStubs: payStubsReducer,
  accruedSickHours: accruedSickHoursReducer,
  // TODO: TECH DEBT this should be changed once a different store per role is built
  upshifterPunchCards: upshifterPunchCardsReducer,
  upshifterUserCertificatesReducer,
  upshifterNotificationPreferencesReducer,
  favoredBusinessesReducer,
  favorerBusinessesReducer,
  strikes: strikesReducer,
  upshifterExperiences: upshifterExperiencesReducer,
})

export type AppState = ReturnType<typeof rootReducer>

export default rootReducer
